export default __webpack_public_path__ + "static/media/RogueBlitz.c20e2d87.jpg";